<template>
  <div ref="section" class="tray-section">
    <div class="tray-section-heading">
      <a @click.prevent="toggle">
        <span
          :class="[
            'af-icons',
            'af-icons-chevron-' + (isOpen ? 'down' : 'up'),
            'pull-left'
          ]"
        ></span>
        &nbsp;
        {{ title }}
      </a>
    </div>
    <collapsible>
      <slot v-if="isOpen"></slot>
    </collapsible>
  </div>
</template>

<script>
import $ from 'jQuery';
import _ from 'underscore';
import Collapsible from '@/lib/components/Shared/Collapsible';
import Storage from '@/lib/storage.js';

const Visibility = Object.freeze({
  OPEN: 'open',
  CLOSED: 'closed'
});

export default {
  components: {
    Collapsible
  },
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    initiallyCollapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: !this.initiallyCollapsed
    };
  },
  created() {
    this.storage = new Storage();

    const visibility = this.storage.get(this.id);

    if (visibility) {
      this.isOpen = visibility === Visibility.OPEN;
    }
  },
  mounted() {
    this.initObserver();
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      this.storage.set(
        this.id,
        this.isOpen ? Visibility.OPEN : Visibility.CLOSED
      );
    },
    onResize() {
      setTimeout(() => $(window).trigger('resize'), 300);
    },
    initObserver() {
      this.debouncedOnResize = _.debounce(this.onResize, 300);

      // The MutationObserver is used to detect any changes within the section element
      // (elements hidden/shown) and trigger the resize event. Ideally this should be
      // done using ResizeObserver, but the browser support is sketchy.
      const observer = new MutationObserver(() => {
        this.debouncedOnResize();
      });

      this.observer = observer.observe(this.$refs.section, {
        childList: true,
        subtree: true
      });
    }
  }
};
</script>
